import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FloatoverComponent } from './floatover.component'
import { IonicModule } from '@ionic/angular'
import { NgxFloatUiModule } from 'ngx-float-ui'

@NgModule({
  declarations: [FloatoverComponent],
  imports: [CommonModule, IonicModule, NgxFloatUiModule],
  exports: [FloatoverComponent],
})
export class FloatoverModule {}
